import { Fragment } from 'react';
import { Button, Card, Col, Form, InputGroup, Row } from 'react-bootstrap';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step12Honorarios(props: RelatorioCivelStepProps) {
  const {
    cardStyle,
    headerStyle,
    RELATORIO_CORES,
    apenasNumeros,
    quantidadeLinhas,
    setQuantidadeLinhas,
    formData,
    renderTabelaProcessosSimples,
    isViewMode,

    // Sentença/Acórdão
    novoProcessoSentencaAcordao,
    setNovoProcessoSentencaAcordao,
    adicionarHonorarioSentencaAcordao,
    adicionarMultiplasLinhasHonorariosSentencaAcordao,
    removerHonorarioSentencaAcordao,
    editandoHonorarioSentencaAcordao,
    valorEdicaoProcessoSentencaAcordao,
    setValorEdicaoProcessoSentencaAcordao,
    iniciarEdicaoHonorarioSentencaAcordao,
    salvarEdicaoHonorarioSentencaAcordao,
    cancelarEdicaoHonorarioSentencaAcordao,

    // Cumprimento
    novoProcessoCumprimento,
    setNovoProcessoCumprimento,
    adicionarHonorarioCumprimento,
    adicionarMultiplasLinhasHonorariosCumprimento,
    removerHonorarioCumprimento,
    editandoHonorarioCumprimento,
    valorEdicaoProcessoCumprimento,
    setValorEdicaoProcessoCumprimento,
    iniciarEdicaoHonorarioCumprimento,
    salvarEdicaoHonorarioCumprimento,
    cancelarEdicaoHonorarioCumprimento,
  } = props;

  return (
    <Fragment>
      {/* Sub-etapa 1: Sentença/Acórdão com fixação de honorários */}
      <Card className="mb-4" style={cardStyle}>
        <Card.Header style={headerStyle}>
          <h6 className="mb-0">
            <i className="bi bi-file-earmark-text me-2"></i>
            Sentença/Acórdão com fixação de honorários advocatícios em favor da Defensoria Pública
          </h6>
        </Card.Header>
        <Card.Body>
          {!isViewMode && (
            <>
              <Row className="mb-3">
                <Col md={10}>
                  <Form.Group>
                    <Form.Label className="fw-bold">N.º do Processo</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Ex: 000000.000.000"
                        value={novoProcessoSentencaAcordao}
                        onChange={(e) => setNovoProcessoSentencaAcordao(apenasNumeros(e.target.value))}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            adicionarHonorarioSentencaAcordao();
                          }
                          if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                            e.preventDefault();
                          }
                        }}
                        style={{ borderRadius: '8px 0 0 8px' }}
                      />
                      <Button
                        variant="primary"
                        onClick={adicionarHonorarioSentencaAcordao}
                        style={{ borderRadius: '0 8px 8px 0' }}
                      >
                        <i className="bi bi-plus-lg me-2"></i>
                        Adicionar
                      </Button>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      Pressione Enter ou clique em Adicionar para incluir o processo na lista
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-muted">Adicionar</span>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosSentencaAcordao: Math.max(1, prev.honorariosSentencaAcordao - 1),
                        }))
                      }
                      style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <i className="bi bi-dash">-</i>
                    </Button>
                    <Form.Control
                      type="number"
                      min="1"
                      max="50"
                      value={quantidadeLinhas.honorariosSentencaAcordao}
                      onChange={(e) =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosSentencaAcordao: Math.max(1, parseInt(e.target.value) || 1),
                        }))
                      }
                      style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                      size="sm"
                    />
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosSentencaAcordao: Math.min(50, prev.honorariosSentencaAcordao + 1),
                        }))
                      }
                      style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <i className="bi bi-plus">+</i>
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={adicionarMultiplasLinhasHonorariosSentencaAcordao}
                      style={{ borderRadius: '8px' }}
                    >
                      <i className="bi bi-plus-lg me-1"></i>
                      Adicionar {quantidadeLinhas.honorariosSentencaAcordao} linha
                      {quantidadeLinhas.honorariosSentencaAcordao > 1 ? 's' : ''}
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
          )}

          {renderTabelaProcessosSimples(
            formData.honorarios.sentencaAcordao,
            removerHonorarioSentencaAcordao,
            editandoHonorarioSentencaAcordao,
            valorEdicaoProcessoSentencaAcordao,
            setValorEdicaoProcessoSentencaAcordao,
            iniciarEdicaoHonorarioSentencaAcordao,
            salvarEdicaoHonorarioSentencaAcordao,
            cancelarEdicaoHonorarioSentencaAcordao,
          )}

          <div className="mt-2 text-end">
            <h5 className="mb-0" style={{ color: RELATORIO_CORES.PRIMARIA }}>
              <small className="text-muted">Total de Processos:</small> {formData.honorarios.sentencaAcordao.length}
            </h5>
          </div>
        </Card.Body>
      </Card>

      {/* Sub-etapa 2: Cumprimento de Sentença de Honorários */}
      <Card className="mb-4" style={cardStyle}>
        <Card.Header style={headerStyle}>
          <h6 className="mb-0">
            <i className="bi bi-file-check me-2"></i>
            Cumprimento de Sentença de Honorários ajuizados em favor da Defensoria Pública
          </h6>
        </Card.Header>
        <Card.Body>
          {!isViewMode && (
            <>
              <Row className="mb-3">
                <Col md={10}>
                  <Form.Group>
                    <Form.Label className="fw-bold">N.º do Processo</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Ex: 000000.000.000"
                        value={novoProcessoCumprimento}
                        onChange={(e) => setNovoProcessoCumprimento(apenasNumeros(e.target.value))}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            adicionarHonorarioCumprimento();
                          }
                          if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                            e.preventDefault();
                          }
                        }}
                        style={{ borderRadius: '8px 0 0 8px' }}
                      />
                      <Button
                        variant="primary"
                        onClick={adicionarHonorarioCumprimento}
                        style={{ borderRadius: '0 8px 8px 0' }}
                      >
                        <i className="bi bi-plus-lg me-2"></i>
                        Adicionar
                      </Button>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      Pressione Enter ou clique em Adicionar para incluir o processo na lista
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-muted">Adicionar</span>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosCumprimento: Math.max(1, prev.honorariosCumprimento - 1),
                        }))
                      }
                      style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <i className="bi bi-dash">-</i>
                    </Button>
                    <Form.Control
                      type="number"
                      min="1"
                      max="50"
                      value={quantidadeLinhas.honorariosCumprimento}
                      onChange={(e) =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosCumprimento: Math.max(1, parseInt(e.target.value) || 1),
                        }))
                      }
                      style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                      size="sm"
                    />
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        setQuantidadeLinhas((prev) => ({
                          ...prev,
                          honorariosCumprimento: Math.min(50, prev.honorariosCumprimento + 1),
                        }))
                      }
                      style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <i className="bi bi-plus">+</i>
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={adicionarMultiplasLinhasHonorariosCumprimento}
                      style={{ borderRadius: '8px' }}
                    >
                      <i className="bi bi-plus-lg me-1"></i>
                      Adicionar {quantidadeLinhas.honorariosCumprimento} linha
                      {quantidadeLinhas.honorariosCumprimento > 1 ? 's' : ''}
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
          )}

          {renderTabelaProcessosSimples(
            formData.honorarios.cumprimento,
            removerHonorarioCumprimento,
            editandoHonorarioCumprimento,
            valorEdicaoProcessoCumprimento,
            setValorEdicaoProcessoCumprimento,
            iniciarEdicaoHonorarioCumprimento,
            salvarEdicaoHonorarioCumprimento,
            cancelarEdicaoHonorarioCumprimento,
          )}

          <div className="mt-2 text-end">
            <h5 className="mb-0" style={{ color: RELATORIO_CORES.PRIMARIA }}>
              <small className="text-muted">Total de Processos:</small> {formData.honorarios.cumprimento.length}
            </h5>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
}

